import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useAccumulatorOverrideStateSchedule from "./hooks/useAccumulatorOverrideStateSchedule";

const AccumulatorOverrideStateSchedule = () => {
  const accumulatorOverrideStateScheduleData =
    useAccumulatorOverrideStateSchedule();
  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={accumulatorOverrideStateScheduleData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {accumulatorOverrideStateScheduleData.screen_title} -{" "}
          <span className="heading-cod">
            {accumulatorOverrideStateScheduleData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={accumulatorOverrideStateScheduleData.formFields}
        dropdownValues={accumulatorOverrideStateScheduleData.dropdownValues}
        paramsData={accumulatorOverrideStateScheduleData.paramsData}
        updataParamData={accumulatorOverrideStateScheduleData.updateParamData}
      />
      <ButtonsSection
        ctaButtons={accumulatorOverrideStateScheduleData.ctaButtons}
      />
      <DisplayTable
        data={accumulatorOverrideStateScheduleData.data}
        parmKey={accumulatorOverrideStateScheduleData.parmKey}
        menuOptions={accumulatorOverrideStateScheduleData.menuOptions}
        tableHeaders={accumulatorOverrideStateScheduleData.columnDef}
        setRowData={accumulatorOverrideStateScheduleData.setRowData}
        selectedPriceSchedules={
          accumulatorOverrideStateScheduleData.selectedRows
        }
        setSelectedPriceSchedules={
          accumulatorOverrideStateScheduleData.setSelectedRows
        }
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={accumulatorOverrideStateScheduleData.first}
          rows={accumulatorOverrideStateScheduleData.rows}
          totalRecords={accumulatorOverrideStateScheduleData.totalRecords}
          currentPage={accumulatorOverrideStateScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={accumulatorOverrideStateScheduleData.onPageChange}
        />
      </div>
      {accumulatorOverrideStateScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={accumulatorOverrideStateScheduleData.isConfirmationModalOpen}
          onRequestClose={
            accumulatorOverrideStateScheduleData.closeConfirmationModal
          }
          onBack={accumulatorOverrideStateScheduleData.closeConfirmationModal}
          onSave={accumulatorOverrideStateScheduleData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={
            accumulatorOverrideStateScheduleData.setSelectedOption
          }
        />
      )}
      {accumulatorOverrideStateScheduleData.isInactiveConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={
            accumulatorOverrideStateScheduleData.isInactiveConfirmationModalOpen
          }
          onRequestClose={
            accumulatorOverrideStateScheduleData.closeInactiveConfirmationModal
          }
          onBack={
            accumulatorOverrideStateScheduleData.closeInactiveConfirmationModal
          }
          onSave={accumulatorOverrideStateScheduleData.inActivateSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={
            accumulatorOverrideStateScheduleData.setInactiveSelectedOption
          }
        />
      )}
    </div>
  );
};
export default AccumulatorOverrideStateSchedule;
